import moment from 'moment';

import ObjectValues from '../../types/ObjectValues';
import { UserRole } from '../constants/users';

export function mapFromUserToUserCSV(user) {
  const { createDate } = user;
  return {
    ...user,
    createDate: createDate ? moment(createDate).format('MM-DD-YYYY') : '',
  };
}

type Role = ObjectValues<typeof UserRole>;

export function getUserRoleLabel(role: Role) {
  switch (role) {
    case UserRole.superAdmin:
      return 'Admin';
    case UserRole.vendor:
      return 'Vendor';
    default:
      return 'BACHer';
  }
}
